import Box, { BoxProps } from "ds/components/Box";

type ScanSettingsFormWrapperProps = Omit<BoxProps, "limitWidth" | "fullWidth">;

const ScanSettingsFormWrapper = ({
  children,
  padding = "x-large",
  gap = "x-large",
  ...restProps
}: ScanSettingsFormWrapperProps) => {
  return (
    <Box
      direction="column"
      padding={padding}
      gap={gap}
      grow="1"
      zeroMinHeight
      limitWidth="medium"
      {...restProps}
    >
      {children}
    </Box>
  );
};

export default ScanSettingsFormWrapper;
